import React, {useState, useContext, useEffect} from 'react'

export const Text = React.createContext()

export default function ContextProvider(props){
   
    // ----- About Us -----
    const aboutUs = "We Build Apps for Small Businesses"

    const whatWeOffer = "Blake Technologies builds apps for small businesses. Contact us to discuss how we can help your business grow."

    // ----- Contact Us -----
    const contactUs = "Tell us about your business and how we can help using the contact form below."

    const testimonials = [ 
    <div className="home-testimonials-fromText">
    "I have full confidence in anything Blake does. When I was struggling with employment in the tech world he helped me make adjustments that landed me a coding job in less than 3 months."
    <br />
    -McKay Burnett | <span className="home-testimonials-career">Full-Stack Web Developer</span>
    </div>,
    <div className="home-testimonials-fromText">
    "Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus."
    <br />
    -Some Dude | <span className="home-testimonials-career">Software Engineer</span>
    </div>,
    <div className="home-testimonials-fromText">
    "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    <br />
    -Another Guy | <span className="home-testimonials-career">App Developer</span>
    </div>
    ]

    const businessDescription = `Get an App for your business without breaking the bank`
    return(
        <Text.Provider
            value={{
                aboutUs,
                whatWeOffer,
                contactUs,
                testimonials,
                businessDescription,
            }}
        >
            {props.children}
        </Text.Provider>
    )
}